import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { AbstractHypeService } from '../../Common/Layout/services/abstract-hype.service';
import { HypeModel } from '../../Common/Layout/models/hype.model';
import { CoreDialogService } from '../../Core/Dialogs/services/dialog.service';
import { ViAgentDialogComponent } from '../components/ViAgentDialog/vi-agent-dialog.component';
import { FullProfileAnimationModel } from '../../Core/Dialogs/models/full-profile-animation.model';
import { FullProfileDialogAnimationsEnum } from '../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../Core/Dialogs/enums/overlay-animation.enum';
import { ViRoutingService } from './vi-routing.service';

@Injectable()
export class ViHypeService extends AbstractHypeService {
    constructor(
        private coreDialogService: CoreDialogService,
        private viRoutingService: ViRoutingService
    ) {
        super();
        this.hypeConfig = {
            icon: 'fa-kit-duotone fa-agpr-ai-visibility',
            headingText: 'VisibilityIntelligence.hype.headline',
            line1Text: 'VisibilityIntelligence.hype.line1',
            line2Text: 'VisibilityIntelligence.hype.line2',
            line2Bold: true,
            multiColumns: true,
            firstIcon: 'fa-kit-duotone fa-agpr-vi-monitor',
            firstHeadingText: 'VisibilityIntelligence.hype.firstHeadingText',
            firstLineText: 'VisibilityIntelligence.hype.firstLineText',
            firstLinkText: 'VisibilityIntelligence.hype.firstLinkText',
            secondaryIcon: 'fa-duotone fa-regular fa-messages-question',
            secondaryHeadingText: 'VisibilityIntelligence.hype.secondaryHeadingText',
            secondaryLineText: 'VisibilityIntelligence.hype.secondaryLineText',
            secondaryLinkText: 'VisibilityIntelligence.hype.secondaryLinkText',
            hideButtonIcon: true,
        } as HypeModel;
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    buttonClicked(): void {
        this.viRoutingService.gotoNew();
    }

    secondaryButtonClicked(): void {
        this.coreDialogService.open(ViAgentDialogComponent, {
            inputs: {
                animationTrigger: new BehaviorSubject(
                    new FullProfileAnimationModel(
                        FullProfileDialogAnimationsEnum.slideInOutAnimation,
                        OverlayAnimationStateEnum.open
                    )
                ),
                overlayContainer: document.getElementById('main-content')
            }
        });
    }
}
